import React from 'react';
import { BlurUpImage } from '../../../shared/components/BlurUpImage';
import {
  MARKETING_PLACEHOLDERS,
  MARKETING_DOMINANT_COLORS,
} from '../../../shared/marketing-placeholders';

/**
 * Forecast Spotlight section card.
 *
 * Premium product window with two Forecast moments: the summary (remaining,
 * estimated, time spent, sprints, releases) and the distribute-to-release
 * view that spreads the planned work across upcoming releases.
 *
 * Images lazy-load (default) — the panel mounts only when its explorer
 * tab is first opened, so it never competes with the LCP.
 */

export function ForecastSpotlightCard(): React.ReactElement {
  return (
    <div className="forecast-spotlight">
      <div className="forecast-spotlight__frame product-window">
        <div className="forecast-spotlight__viewport forecast-spotlight__viewport--summary">
          <BlurUpImage
            src="/brand/solutions/forecast-moment.png"
            webpSrc="/brand/solutions/forecast-moment-original.webp"
            placeholderSrc={MARKETING_PLACEHOLDERS['forecast-moment']}
            dominantColor={MARKETING_DOMINANT_COLORS['forecast-moment']}
            alt="Relix Forecast summary: remaining days, estimated days, time spent, sprints and releases ahead"
            width={1280}
            height={720}
            className="forecast-spotlight__shot"
          />
          <span className="forecast-spotlight__shot-veil" aria-hidden="true" />
        </div>
        <div className="forecast-spotlight__divider" aria-hidden="true">
          <span className="forecast-spotlight__divider-label">Distribute to release</span>
        </div>
        <div className="forecast-spotlight__viewport forecast-spotlight__viewport--distribute">
          <BlurUpImage
            src="/brand/solutions/distribute-moment.png"
            webpSrc="/brand/solutions/distribute-moment-original.webp"
            placeholderSrc={MARKETING_PLACEHOLDERS['distribute-moment']}
            dominantColor={MARKETING_DOMINANT_COLORS['distribute-moment']}
            alt="Relix Forecast distribution: planned work spread across the upcoming releases"
            width={1280}
            height={720}
            className="forecast-spotlight__shot"
          />
        </div>
      </div>
    </div>
  );
}
